module.exports = __webpack_public_path__ + "img/SendBillDisable.e17041a4.svg";